/*
*###############################################################################
*Module Name                   : CustomerMaster.js                             #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Friday, September 10th 2021, 10:14:01 am      #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/
//heyyy/
//119
//--9

import React, { useState, useEffect, useContext } from "react"
import MetaTags from "react-meta-tags"
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    TabContent,
    TabPane,
    Alert,
} from "reactstrap"


//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
//Import DPComponents
import DPNavBar from "../../../framework/widgets/DPNavBar"
import DPTopToolBar from "../../../framework/widgets/DPTopToolBar"
import DPAlert from "framework/widgets/DPAlert"
import Noimage from "assets/images/product/noimage.jpg"
import { Text, Numeric, DecimalValidation } from "../../../framework/validators/TextValidation"
import DPInfoBox from "framework/layout/DPInfoBox"
import CustomerMasterTab1 from "../Customer-Master/CustomerMasterTab1"
import CustomerMasterTab2 from "../Customer-Master/CustomerMasterTab2"
import CustomerMasterTab3 from "../Customer-Master/CustomerMasterTab3"
import CustomerMasterTab4 from "../Customer-Master/CustomerMasterTab4"
import CustomerMasterTab5 from "../Customer-Master/CustomerMasterTab5"
import CustomerMasterTab6 from "../Customer-Master/CustomerMasterTab6"
import CustomerMasterTab7 from "../Customer-Master/CustomerMasterTab7"
import CustomerMasterTab8 from "./CustomerMasterTab8"
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPPermission from "framework/widgets/DPPermission"
import * as XLSX from "xlsx";
import DPPrintOption from "framework/widgets/DPPrintOptions"

import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';
import { SaveCustomer } from "./CusstomerMasterController"
import CustomerMasterTab9 from "./CustomerMasterTab9"

const photovalues = {
    imageSrc: Noimage,
    imageFile: "",
    imagepath: ""
}

const CustomerMaster = (props) => {

    let history = useHistory();
    const customerCodeID = props.location.search.replace("?", "")
    /*************TAB 1 */
    const [strCusCode, SetCode] = useState("")
    const [strCusDesc, SetDesc] = useState("")
    const [strCusFName, SetFName] = useState("")
    const [strCusLName, SetLName] = useState("")
    const [strCusFullName, SetFullName] = useState("")
    const [strCusGroup, SetGroup] = useState("")
    const [strCusRefCode, SetRefCode] = useState("")
    const [strCusNIC, SetNIC] = useState("")
    const [strCusRefCodeGL, SetRefCodeGL] = useState("")
    const [IsActive, SetActive] = useState(true)//Set Active state
    const [strCusLocation, SetLocation] = useState("")
    const [picture, setPicture] = useState(photovalues);
    const [imgName, setImgName] = useState("")
    const [file, SetFile] = useState("")
    const [name1, Setname1] = useState("")
    const [name2, Setnam2] = useState("")
    const [filevalue, SetFileValue] = useState("")
    const [menuCode, SetMenuCode] = useState("")
    const [handleClear, setHandleClear] = useState(false)
    /*************TAB 1 END */

    /*************TAB 2 */
    const [strCusAdd1, SetAdd1] = useState("")
    const [strCusAdd2, SetAdd2] = useState("")
    const [strCusAdd3, SetAdd3] = useState("")
    const [strCusAdd4, SetAdd4] = useState("")
    const [strCusAre, SetArea] = useState("")
    const [strCusMobile1, SetMobile1] = useState("")
    const [strCusMobile2, SetMobile2] = useState("")
    const [strCusMobile3, SetMobile3] = useState("")
    const [strCusMobile4, SetMobile4] = useState("")
    const [strCusFax, SetFax] = useState("")
    const [strCusEmail, SetEmail] = useState("")
    /*************TAB 2 END*/

    /*************TAB 3 */
    const [strCusCredit, SetCredit] = useState("0")
    const [strCusCreditLim, SetCreditLim] = useState("0")
    const [arRow, setarRow] = useState([{
        id: 1,
        code: "",
        desc: "",
        taxreg: "",
        state: false,
        inc: false
    }])
    /*************TAB 3 END*/

    /*************TAB 4 */
    const [strCusGender, SetGender] = useState("")
    const [strCusDOB, SetDOB] = useState("")
    const [strCusTaxState2, SetTaxState2] = useState(false)
    const [strCusSpName, SetSpName] = useState("")
    const [strCusSpDOB, SetSpDOB] = useState("")
    const [strCusWdAniver, SetAniver] = useState("")
    const [strCusProfession, SetProfesion] = useState("")
    const [strCusDesig, SetDesig] = useState("")
    const [strCusCompany, SetCompany] = useState("")
    const [strCusReligion, SetReligion] = useState("")
    const [strCusEthn, SetEthn] = useState("")
    const [aniMonth, SetAniMonth] = useState("")
    const [aniDay, SetAniDay] = useState("")
    /*************TAB 4 END*/

    /*************TAB 5 */
    const [strCusLoyalStae, SetLoyalStae] = useState(0)
    const [strCusLoyalCat, SetLoyalCat] = useState("")
    const [strCusOpenPoint, SetOpenPoint] = useState("0")
    const [strCusFixDiscount, SetFixDiscount] = useState("0")
    const [strCusDisGruop, SetDisGroup] = useState("")
    const [strCusPreLAn, SetPreLan] = useState("")
    const [strCusEbil, SetEbil] = useState(false)
    const [strCusRPEmail, SetRPEmail] = useState(false)
    const [strCUsRPSMS, SetRPSMS] = useState(false)
    const [strCusMobile, SetMobile] = useState(false)
    const [openPoint, SetPoint] = useState(false)
    const [genDOB, SetGenDOB] = useState(false)
    const [loyaltyPoints, SetLoyaltyPoints] = useState(0)
    /*************TAB 5 END*/

    /*************TAB 6 */
    const [strCusProvider, SetProvider] = useState("")
    const [strCusRef, SetRef] = useState("")
    const [vasRow, setVasRow] = useState([{
        id: 1,
        code: "",
        desc: "",
        account: "",
    }])
    const [vasDetails, setVasDetails] = useState([])
    /*************TAB 6 END*/

    /*************Documents Upload (CustomerMasterTab8)*/
    const [selectedAttachFiles, setSelectedAttachFiles] = useState([])
    const [attachFileNames, setAttachFileNames] = useState([]);
    const [clearAttachmentEdit, setClearAttachmentEdit] = useState(false)
    const [handleClearStatus, setHandleClearStatus] = useState(false)
    /*************TAB 8 END*/


    /*******TAB 9 */
    const [references, setReferences] = useState({
        reference1: "",
        reference2: "",
        reference3: "",
        reference4: "",
        reference5: "",
    })






    //*** User Activity related states*/
    const [show, setShow] = useState(false)
    const [AlertMsg, setAlertMsg] = useState('')
    const [AlertColor, setAlertColor] = useState('')
    const [modal_xlarge, setmodal_xlarge] = useState(false)
    const [disabled, setDisabled] = useState(false)
    const [disabledCode, setDisabledCode] = useState(false)
    const [saveEnable, setSaveEnable] = useState(true)
    const [crEnable, setCrEnable] = useState(false)
    const [crBy, setCrBy] = useState("")
    const [mdBy, setMdBy] = useState("")
    const [crDate, setCrDate] = useState("")
    const [mdDate, setMdDate] = useState("")
    const [customActiveTab, setcustomActiveTab] = useState("1")
    const [deleteEnable, SetDeleteEnable] = useState(false)
    const [Reason, setReason] = useState("Created")
    const [editEnable, SetEditEnable] = useState(false)
    //*** End User activity related staes */

    //Alert Parameter
    const [sweetAlertShow, setsweetAlertShow] = useState(false)
    const [AlertDescription, setAlertDescription] = useState(false)
    const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
    const [ErrorMsg, setErrorMsg] = useState('')
    const [addNew, SetAddNew] = useState(true)

    //*****Alert Time setter */
    var time = process.env.REACT_APP_ALERTTIMEOUT

    const authToken = localStorage.getItem("authToken")
    const ApiURL = window.Links.ApiURL

    const [menuAccess, SetMenuAccess] = useState(false)
    const [menuCreate, SetMenuCreate] = useState(false)
    const [menuDelete, SetMenuDelete] = useState(false)
    const [menuModify, SetMenuModify] = useState(false)
    const [menuPrint, SetMenuPrint] = useState(false)
    const [menuProcess, SetMenuProcess] = useState(false)
    const [menuName, SetMenuName] = useState("")
    const [parentName, SetParentName] = useState("")
    const [LocationCode, setLocationCode] = useState("")
    const [LogUserType, setLogUserType] = useState("")
    const [LogCompanyCode, setLogCompanyCode] = useState("")
    //*****Menu Rights End */

    /**********Loading Alert */
    const [loadingAlert, SetLoadingAlert] = useState(false)
    const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
    /**********End Loading Alert */

    //autocode generation related newly added code
    const [codeButton, setCodeButton] = useState(true)
    const [searchdisabled, setSearchdisabled] = useState(false)
    const [DisableSearch, SetDisableSearch] = useState(false)
    const [nullCode, setNullCode] = useState(false)
    const [autoCode, setAutoCode] = useState(false)

    //User Permission related usestates
    const [permissionAlertShow, setPermissionAlertShow] = useState(false)
    const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
    const [permissionReasonShow, setPermissionReasonShow] = useState(false)
    const [permissionName, setPermissionName] = useState("")
    const [permissionPassword, setPermissionPassword] = useState("")
    const [permissionNameDisable, setPermissionNameDisable] = useState(false)
    const [printoptionShow, setprintoptionShow] = useState(false)
    const [valueUpload, setvalueUpload] = useState("")
    const [items, setItems] = useState([]);
    const [Excelitems, setExcelItems] = useState([]);
    const [ExcelSheet2, setExcelSheet2] = useState([]);
    const [ExcelSheet3, setExcelSheet3] = useState([]);

    const [currentPage, setCurrentPage] = useState(1)
    const [currentPageRest, setCurrentPageRest] = useState(false)
    const [helpUrl, setHelpUrl] = useState("")

    //import from contexts
    const {
        fieldManager,
        getNonEditable,
        isHeadOffice,
        getMenuDetails,
        masterAuditLog,
        getSelectedMasterPermissions,
        fetchAutoCode,
        addtoFavourite,
        mobileNumberRegexp,
        emailRegexp,
        validateCustomerNIC
    } = useContext(Context);
    //import from contexts

    useEffect(() => {
        getNonEditable(menuCode);
    }, [menuCode]);

    //**Get File Details */
    useEffect(async () => {
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var menuDetail = await getMenuDetails(window.location.pathname)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
        var parentname = menuDetail?.parentName
        SetParentName(parentname)
        var LocationCode = obj[3]
        var CompanyCode = obj[5]
        setLocationCode(LocationCode)
        setLogUserType(LogUserType)
        setLogCompanyCode(CompanyCode)

        var responseData = await getSelectedMasterPermissions(LogUserType, menu)

        if (!responseData.strMenuAccessRight) {
            history.push('/dashboard')
        }

        SetMenuAccess(responseData.strMenuAccessRight)
        SetMenuCreate(responseData.strMenuCreateRight)
        SetMenuDelete(responseData.strMenuDeleteRight)
        SetMenuModify(responseData.strMenuModifyRight)
        SetMenuPrint(responseData.strMenuPrintRight)
        SetMenuProcess(responseData.strMenuProcessRight)
        SetMenuName(responseData.strMenuName)
        SetMenuCode(responseData.strMenuTag)
        setPermissionReasonShow(responseData.strMenuReasonShow)
        setHelpUrl(responseData.strHelpUrl)

        var autoCodeRes = await fetchAutoCode(menu)

        if (autoCodeRes.nullCode == false) {
            setAutoCode(autoCodeRes.autoCode)
        } else {
            setNullCode(true)
            setAutoCode("")
        }

    }, [strCusCode])

    // AuditLog
    useEffect(async () => {
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var LocationCode = obj[3]
        var CompanyCode = obj[5]
        var menuDetail = await getMenuDetails(window.location.pathname)
        var menu =
            menuDetail && menuDetail.menuTag
                ? menuDetail.menuTag
                : history.push("/dashboard")

        await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log
    }, [])


    useEffect(() => {
        if (customerCodeID.length > 0) {
            getData(customerCodeID)
        }
    }, [])

    const readExcel = (file) => {

        const promise = new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsArrayBuffer(file);

            fileReader.onload = (e) => {
                const bufferArray = e.target.result;

                const wb = XLSX.read(bufferArray, { type: "buffer" });

                const wsname = wb.SheetNames[0];
                const wsname2 = wb.SheetNames[1];
                const wsname3 = wb.SheetNames[2];

                const ws = wb.Sheets[wsname];

                const data = XLSX.utils.sheet_to_json(ws);
                const data2 = XLSX.utils.sheet_to_json(wb.Sheets[wsname2]);
                const data3 = XLSX.utils.sheet_to_json(wb.Sheets[wsname3]);

                setExcelItems(data);
                setExcelSheet2(data2);
                setExcelSheet3(data3);

                resolve(data);
            };

            fileReader.onerror = (error) => {
                reject(error);
            };
        });

        promise.then((d) => {
            setItems(d);
        });
    };


    //*** Get and Set values when user search code */
    const getData = (searchcode) => {

        if (validateSpecialCharacters(searchcode) == true) {
            SetCode("")
            return
        }

        if (searchcode != "") {

            SetLoadingAlert(true)
            SetLoadingAlerttitle("Fetching...")
            SetDisableSearch(true)



            fetch(`${ApiURL}Customer/search/${searchcode}`, {
                method: "GET",
                headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` }
            }).then(Response => Response.json())
                .then(responseData => {
                    SetLoadingAlert(false)
                    if (responseData.success == true) {

                        let modifiedRows = []
                        let modifiedRowsVas = []
                        const newArray = [...responseData.data]

                        SetCode(newArray[0].strCode),
                            SetDesc(newArray[0].strTitle), SetFName(newArray[0].strFName),
                            SetLName(newArray[0].strLName), SetFullName(newArray[0].strFullName),
                            SetGroup(newArray[0].strGroup), SetRefCode(newArray[0].strLinkRef),
                            SetNIC(newArray[0].strNIC), SetRefCodeGL(newArray[0].strGlCode),
                            SetActive(newArray[0].intStatus), SetLocation(newArray[0].strLocation),
                            SetAdd1(newArray[0].strAddress1), SetAdd2(newArray[0].strAddress2),
                            SetAdd3(newArray[0].strAddress3), SetAdd4(newArray[0].strAddress4),
                            SetArea(newArray[0].strArea), SetMobile1(newArray[0].strMobile1), SetMobile2(newArray[0].strMobile2),
                            SetMobile3(newArray[0].strPhone1), SetMobile4(newArray[0].strPhone2),
                            SetFax(newArray[0].strFax), SetEmail(newArray[0].strEmail),
                            SetCredit(newArray[0].intCreditPerid), SetCreditLim(newArray[0].dblCreditLimit),
                            SetGender(newArray[0].strGender), SetDOB(newArray[0].dtDOB.slice(0, 4) == "1900" ? "" : newArray[0].dtDOB.slice(0, 10)),
                            SetTaxState2(newArray[0].intCivilState), SetSpName(newArray[0].strSpouse),
                            SetSpDOB(newArray[0].dtSpouseDOB.slice(0, 4) == "1900" ? "" : newArray[0].dtSpouseDOB.slice(0, 10)),
                            SetAniver(newArray[0].dtAnniversary.slice(0, 10)), SetAniMonth(newArray[0].dtAnniversary.slice(0, 4) == "1900" ? "" : newArray[0].dtAnniversary.slice(5, 7)), SetAniDay(newArray[0].dtAnniversary.slice(0, 4) == "1900" ? "" : newArray[0].dtAnniversary.slice(8, 10)),
                            SetProfesion(newArray[0].strProfession),
                            SetDesig(newArray[0].strDesignation), SetCompany(newArray[0].strCompany),
                            SetReligion(newArray[0].strReligion), SetEthn(newArray[0].strEthnicity),
                            SetLoyalStae(newArray[0].intLoyalty), SetLoyalCat(newArray[0].strLoyaltyGroup),
                            SetOpenPoint(newArray[0].dblOpPoints), SetFixDiscount(newArray[0].dblDiscount),
                            SetDisGroup(newArray[0].strDiscountGroup), SetPreLan(newArray[0].strLanguage),
                            SetEbil(newArray[0].intEBill), SetRPEmail(newArray[0].intPromoEmail), SetRPSMS(newArray[0].intPromoSMS),
                            SetMobile(newArray[0].intAppUser), SetProvider(), SetRef(newArray[0].strMenuCode),
                            setCrBy(newArray[0].createdBy), setMdBy(newArray[0].modifiedBy),
                            setCrDate(newArray[0].createdDate), setMdDate(newArray[0].modifiedDate == "1900-01-01T00:00:00" ? "" : newArray[0].modifiedDate), SetFile(newArray[0].strFolder),
                            SetLoyaltyPoints(newArray[0].loyaltypoints)

                        setSelectedAttachFiles([])
                        setAttachFileNames(newArray[0].customerAttachments)
                        setHandleClear(prev => !prev)

                        setPicture(newArray[0].strImageUrl == "images/customer/" ? photovalues : {
                            imageSrc: `${window.Links.MediaServer + localStorage.getItem("Serial") + "/"}${newArray[0].strImageUrl}`,
                        }), setImgName(newArray[0].strImageUrl)

                        SetFileValue("")
                        setVasDetails()
                        SetGenDOB(newArray[0].strNIC == "" ? false : true)
                        SetPoint(newArray[0].dblOpPoints == 0 ? false : true)

                        newArray[0].tblCustomerTaxDetails.map((dr) => {
                            modifiedRows.push({ id: modifiedRows.length + 1, code: dr.taccode, desc: dr.taccode, taxreg: dr.taxreg, state: dr.status, inc: dr.taxinc, taxCodeDisable: true })

                        }),

                            newArray[0].tblCustomerVASDetails.map((dr) => {
                                SetAddNew(false)
                                modifiedRowsVas.push({ id: modifiedRowsVas.length + 1, code: dr.vcM_CODE, provider: dr.vcM_PROVIDER, account: dr.vcM_ACCOUNT })
                            })

                        SetAddNew(false)
                        setDisabled(true)
                        setDisabledCode(true)
                        setSaveEnable(false)
                        setCrEnable(true)
                        SetDeleteEnable(true)
                        setSearchdisabled(true)
                        SetDisableSearch(true)
                        setReason("Updated")
                        SetEditEnable(true)
                        setCurrentPageRest(prev => !prev)
                        setVasRow(modifiedRowsVas == undefined || modifiedRowsVas.length == 0 ? [{
                            id: 1,
                            code: "",
                            desc: "",
                            account: ""
                        }] : modifiedRowsVas)
                        setarRow(modifiedRows == undefined || modifiedRows.length == 0 ? [{
                            id: 1,
                            code: "",
                            desc: "",
                            taxreg: "",
                            state: false,
                            inc: false
                        }] : modifiedRows)

                        setReferences({
                            reference1: newArray[0].reference1,
                            reference2: newArray[0].reference2,
                            reference3: newArray[0].reference3,
                            reference4: newArray[0].reference4,
                            reference5: newArray[0].reference5
                        })

                    } else {

                        if (nullCode == false) {
                            displayAlertMessage('success', "Record Not Found !")
                            setDisabledCode(true)
                            SetDisableSearch(true)
                            SetCode("")
                        } else {
                            displayAlertMessage('success', "Record Not Found !")
                        }
                    }
                })
        }
    }



    const rerefencesOnChange = (e) => {
        const { name, value } = e.target;

        //check length of the value
        if (value.length > 50) {
            return;
        }

        setReferences({ ...references, [name]: value });
    }





    //******Save function */
    const handlesave = async () => {
        var ExcelItemsRows = [...Excelitems]
        var ExcelSheet2Rows = [...ExcelSheet2]
        var ExcelSheet3Rows = [...ExcelSheet3]

        var rowcount = ExcelItemsRows.length
        var errorcount = 0
        var j = 0
        if (Array.isArray(ExcelItemsRows) && ExcelItemsRows.length) {

            var mapexport = ExcelItemsRows.map(
                async (localState, key) => {

                    j++
                    if ((localState.Code != null) && (localState.Description != null) && (localState.FirstName != null) && (localState.Group != null) && (localState.Location != null) && (localState.Address1 != null) && (localState.Mobile1 != null)) {

                        var taxTable = []
                        var vasTable = []

                        if (Array.isArray(ExcelSheet2Rows) && ExcelSheet2Rows.length) {
                            ExcelSheet2Rows.map(dr => {
                                if (dr.Code != null && dr.Code == localState.Code) {

                                    var taxcode = dr.TaxCode == null ? "" : dr.TaxCode
                                    var taxreg = dr.TaxRegNo == null ? "" : dr.TaxRegNo
                                    var status = dr.Status == null ? false : dr.Status
                                    var taxinclusive = dr.TaxInclusive == null ? 0 : dr.TaxInclusive

                                    if (dr.TaxCode != null) {
                                        taxTable = taxTable.concat(CustomerTaxBuilder(localState.Code, taxcode, taxreg, status, taxinclusive))
                                    }
                                }
                            })
                        }
                        if (Array.isArray(ExcelSheet3Rows) && ExcelSheet3Rows.length) {
                            ExcelSheet3Rows.map(dr => {
                                if (dr.Code != null && dr.Code == localState.Code) {

                                    var provider = dr.Provider == null ? "" : dr.Provider
                                    var account = dr.Account == null ? "" : dr.Account
                                    if (dr.Provider == null) {
                                        vasTable = vasTable.concat(CustomerVasBuilder(localState.Code, provider, account))
                                    }
                                }
                            })
                        }

                        const VenderArea = {
                            "strCode": localState.Code,
                            "strTitle": localState.Description,
                            "strFName": localState.FirstName,
                            "strLName": localState.LastName == null ? "" : localState.LastName,
                            "strFullName": localState.FullName == null ? localState.FirstName : localState.FullName,
                            "strGroup": localState.Group,
                            "strLinkRef": localState.LinkRef == null ? "" : localState.LinkRef,
                            "strNIC": localState.NIC == null ? "" : localState.NIC,
                            "strGlCode": localState.GlCode == null ? "" : localState.GlCode,
                            "intStatus": localState.Active == null ? false : localState.Active,
                            "strFolder": localState.Folder == null ? "" : localState.Folder,
                            "strLocation": localState.Location,
                            "strAddress1": localState.Address1,
                            "strAddress2": localState.Address2 == null ? "" : localState.Address2,
                            "strAddress3": localState.Address3 == null ? "" : localState.Address3,
                            "strAddress4": localState.Address4 == null ? "" : localState.Address4,
                            "strArea": localState.Area == null ? "" : localState.Area,
                            "strMobile1": localState.Mobile1,
                            "strMobile2": localState.Mobile2 == null ? "" : localState.Mobile2,
                            "strPhone1": localState.Phone1 == null ? "" : localState.Phone1,
                            "strPhone2": localState.Phone2 == null ? "" : localState.Phone2,
                            "strFax": localState.Fax == null ? "" : localState.Fax,
                            "strEmail": localState.Email == null ? "" : localState.Email,
                            "intCreditPerid": localState.CreditPeriod == null ? 0 : localState.CreditPeriod,
                            "dblCreditLimit": localState.CreditLimit == null ? 0 : localState.CreditLimit,
                            "strGender": localState.Gender == null ? "" : localState.Gender,
                            "dtDOB": localState.DOB == null ? "1900-01-01" : localState.DOB,
                            "intCivilState": localState.CivilState == null ? false : localState.CivilState,
                            "strSpouse": localState.Spouse == null ? "" : localState.Spouse,
                            "dtSpouseDOB": localState.SpouseDOB == null ? "1900-01-01" : localState.SpouseDOB,
                            "dtAnniversary": localState.Anniversary == null ? "1900-01-01" : localState.Anniversary,
                            "strProfession": localState.Profession == null ? "" : localState.Profession,
                            "strDesignation": localState.Designation == null ? "" : localState.Designation,
                            "strCompany": localState.Company == null ? "" : localState.Company,
                            "strReligion": localState.Religion == null ? "" : localState.Religion,
                            "strEthnicity": localState.strEthnicity == null ? "" : localState.strEthnicity,
                            "intLoyalty": localState.Loyalty == null ? false : localState.Loyalty,
                            "strLoyaltyGroup": localState.LoyaltyGroup == null ? "" : localState.LoyaltyGroup,
                            "dblOpPoints": localState.OpPoints == null ? 0 : localState.OpPoints,
                            "dblDiscount": localState.Discount == null ? 0 : localState.Discount,
                            "strDiscountGroup": localState.DiscountGroup == null ? "" : localState.DiscountGroup,
                            "strLanguage": localState.Language == null ? "" : localState.Language,
                            "intEBill": localState.EBill == null ? false : localState.EBill,
                            "intPromoEmail": localState.PromoEmail == null ? false : localState.PromoEmail,
                            "intPromoSMS": localState.PromoSMS == null ? false : localState.PromoSMS,
                            "intAppUser": localState.AppUser == null ? false : localState.AppUser,
                            "strimage": "",
                            "tblCustomerTaxDetails": taxTable,
                            "tblCustomerVASDetails": vasTable,
                            "strMenuCode": menuCode,
                            "strLoggedCompany": LogCompanyCode,
                            "strLoggedLocation": LocationCode,
                            "strReason": Reason,
                            "strCreatedBy": LogUserType,
                            "blAddNew": addNew
                        }


                        await fetch(`${ApiURL}customer`,
                            {
                                method: "POST",
                                headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
                                body: JSON.stringify(VenderArea),
                            }
                        ).then(async (Response) => {
                            if (Response.status == "200") {
                                await Response.json()
                                    .then(responseData => {
                                        if (responseData.data == "Record Already Exsist!") {
                                            errorcount++
                                        } else if (responseData.data == "Code Already Exsist!") {
                                            errorcount++
                                        }
                                    }
                                    )
                            } else if (Response.status == "400") {
                                errorcount++
                            } else {
                                errorcount++
                            }
                        })
                    } else {
                        errorcount++
                    }
                }
            )

            await Promise.all(mapexport)

            if (errorcount == 0) {
                setAlertColor('success')
            } else {
                setAlertColor('danger')
            }
            setAlertMsg(`From ${rowcount} Records, ${rowcount - errorcount} Records Uploaded Successfully and ${errorcount} Records Failed to Upload`)
            setShow(true)
            setTimeout(() => {
                setShow(false)
                ClearItem()
            }, time)



        } else {

            //set autogenerate code to as CODE just for display purpuse
            if (addNew == true && nullCode == false) {

                SetCode(autoCode)
            }

            var NIC = strCusNIC
            //var mobilePattern = new RegExp(/^[0-9\b]+$/);
            var mobilePattern = new RegExp(mobileNumberRegexp);
            var nicPattern1 = /[0-9]{12}/;
            var nicPattern2 = /[0-9]{9}[V|X|v|x]/;
            var emailPattern = new RegExp(emailRegexp)

            if (strCusCode == "" && nullCode == true) {
                displayAlertMessage('danger', "Please Enter Customer Code !")
                return;
            }
            if (strCusDesc == "") {
                displayAlertMessage('danger', "Please Select Customer Title !")
                return;
            }

            if (strCusFName == "") {
                displayAlertMessage('danger', "Please Enter First Name !")
                return;
            }

            if (strCusFullName == "") {
                displayAlertMessage('danger', "Please Enter Full Name !")
                return;
            }

            if (strCusGroup == "") {
                displayAlertMessage('danger', "Please Select Customer Group !")
                return;
            }

            if (strCusLocation == "") {
                displayAlertMessage('danger', "Please Select Customer Location !")
                return;
            }

            if (NIC != "" || validateCustomerNIC == 1) {

                if (NIC == "" || (NIC.length !== 12 && NIC.length !== 10)) {
                    displayAlertMessage('danger', NIC == "" ? "Please Enter NIC Number!" : "Invalid NIC number");
                    return;
                }

                if ((NIC.length === 12 && !nicPattern1.test(NIC)) || (NIC.length === 10 && !nicPattern2.test(NIC))) {
                    displayAlertMessage('danger', 'Invalid NIC number');
                    return;
                }
            }

            if (strCusAdd1 == "") {
                displayAlertMessage('danger', "Address Line 1 can not be Empty !")
                return;
            }

            if (strCusEmail != "" & !emailPattern.test(strCusEmail)) {
                displayAlertMessage('danger', "Email is not valid")
                return;
            }


            if (strCusFixDiscount == "") {
                SetFixDiscount("0")
            }
            if (parseFloat(strCusFixDiscount) > 100) {
                displayAlertMessage('danger', 'Fix Discount can not over 100 or less than 0')
                return
            }

            if (!aniMonth == "" && aniDay == "") {
                displayAlertMessage('danger', 'Aniversary Date cannot be empty !')
                return
            }
            if (!aniDay == "" && aniMonth == "") {
                displayAlertMessage('danger', 'Aniversary Month cannot be empty !')
                return
            }

            if (strCusGender == "") {
                SetGender("U")
            }

            if (selectedAttachFiles.length > 0) {
                displayAlertMessage("danger", `Please upload the selected files before save !`)
                setcustomActiveTab("8")
                return false
            }

            var CustomerTax = [];


            for (var i = 0; i < arRow.length; i++) {

                if (arRow[i].code != "") {
                    if (arRow[i].taxreg == "") {
                        displayAlertMessage('danger', "Reg Number empty in row number " + (i + 1) + " !")
                        return;
                    }
                    CustomerTax.push(CustomerTaxBuilder(strCusCode, arRow[i].code, arRow[i].taxreg, arRow[i].state, arRow[i].inc))

                }

            }


            var CustomerVas = [];
            for (var i = 0; i < vasRow.length; i++) {

                if (vasRow[i].code != "") {
                    if (vasRow[i].account == "") {
                        displayAlertMessage('danger', "Account Number can not be empty !")
                        return;
                    }
                    CustomerVas.push(CustomerVasBuilder(strCusCode, vasRow[i].code, vasRow[i].account))

                }

            }

            const customerCode = addNew == true && nullCode == false ? autoCode : strCusCode
            if (customerCode == "") {
                displayAlertMessage("danger", `Please enter customer code!`)
                return false
            }
            //Image upload
            var image = []
            image = await CustomerMasterImageUpload(customerCode)


            var EBill = strCusEbil == true ? true : false
            var Status = IsActive == true ? true : false
            var appuser = strCusMobile == true ? true : false
            var Loyal = strCusLoyalStae == true ? true : false
            var Sms = strCUsRPSMS == true ? true : false
            var CivilState = strCusEbil == true ? true : false
            var Email = strCusRPEmail == true ? true : false
            var spDOB = strCusSpDOB == "" ? "1900-01-01" : strCusSpDOB
            var Birthday = strCusDOB == "" ? "1900-01-01" : strCusDOB

            if (aniMonth == "" && aniDay == "") {
                var Aniversary = "1900-01-01"
            } else {
                var Aniversary = "1901-" + aniMonth + "-" + aniDay
            }


            var customerBody = JSON.stringify({
                "strCode": customerCode,
                "strTitle": strCusDesc,
                "strFName": strCusFName,
                "strLName": strCusLName,
                "strFullName": strCusFullName,
                "strGroup": strCusGroup,
                "strLinkRef": strCusRefCode,
                "strNIC": strCusNIC,
                "strGlCode": strCusRefCodeGL,
                "intStatus": Status,
                "strFolder": file,
                "strLocation": strCusLocation,
                "strAddress1": strCusAdd1,
                "strAddress2": strCusAdd2,
                "strAddress3": strCusAdd3,
                "strAddress4": strCusAdd4,
                "strArea": strCusAre,
                "strMobile1": strCusMobile1,
                "strMobile2": strCusMobile2,
                "strPhone1": strCusMobile3,
                "strPhone2": strCusMobile4,
                "strFax": strCusFax,
                "strEmail": strCusEmail,
                "intCreditPerid": parseInt(strCusCredit),
                "dblCreditLimit": parseFloat(strCusCreditLim),
                "strGender": strCusGender,
                "dtDOB": Birthday,
                "intCivilState": CivilState,
                "strSpouse": strCusSpName,
                "dtSpouseDOB": spDOB,
                "dtAnniversary": Aniversary,
                "strProfession": strCusProfession,
                "strDesignation": strCusDesig,
                "strCompany": strCusCompany,
                "strReligion": strCusReligion,
                "strEthnicity": strCusEthn,
                "intLoyalty": Loyal,
                "strLoyaltyGroup": strCusLoyalCat,
                "dblOpPoints": strCusOpenPoint == "" ? 0 : parseFloat(strCusOpenPoint),
                "dblDiscount": strCusFixDiscount == "" ? 0 : parseFloat(strCusFixDiscount),
                "strDiscountGroup": strCusDisGruop,
                "strLanguage": strCusPreLAn,
                "intEBill": EBill,
                "intPromoEmail": Email,
                "intPromoSMS": Sms,
                "intAppUser": appuser,
                "strimage": image,
                "tblCustomerTaxDetails": CustomerTax,
                "tblCustomerVASDetails": CustomerVas,
                "attachmentList": attachFileNames,
                "strMenuCode": menuCode,
                "strLoggedCompany": LogCompanyCode,
                "strLoggedLocation": LocationCode,
                "strReason": Reason,
                "strCreatedBy": LogUserType,
                "blAddNew": addNew,
                "reference1": references.reference1,
                "reference2": references.reference2,
                "reference3": references.reference3,
                "reference4": references.reference4,
                "reference5": references.reference5
            });

            //loading alert show
            SetLoadingAlert(true)
            if (addNew == true) {
                SetLoadingAlerttitle("Saving...")
            } else {
                SetLoadingAlerttitle("Updating...")
            }

            const result = await SaveCustomer(customerBody)
            SetLoadingAlert(false)

            if (result.success) {
                displayAlertMessage('success', result.data)
                ClearItem()
            } else {
                if (result.data == "Code Already Exist!") {
                    displayAlertMessage('danger', result.data)
                    setCodeButton(false)
                } else {
                    displayAlertMessage('danger', result.data)
                }
            }
        }
    }


    //************ Image Upload Function */
    const CustomerMasterImageUpload = async (customerCode) => {

        var message
        if (picture.imageFile != null) {
            var formdata = new FormData()
            formdata.append("strCode", customerCode)
            formdata.append("strSerial", !localStorage.getItem("Serial") ? "" : localStorage.getItem("Serial"))
            formdata.append("img", picture.imageFile)

            var requestOptions = {
                method: 'POST',
                headers: {
                    "Authorization": `Bearer ${authToken}`
                },
                body: formdata,
                redirect: 'follow'
            };

            await fetch(`${ApiURL}customer/image`, requestOptions)
                .then(response =>
                    response.json()
                        .then(responseData => {
                            message = responseData.data
                        })
                )
                .catch(error => console.log('error', error));
        } else if (imgName != null) {
            message = imgName.slice(16,)
        } else {
            message = ""
        }

        return message
    }
    //************ Image Upload Function End*/

    //**********Tax Table Object */
    const CustomerTaxBuilder = (strCusCode, taxcode, taxReg, status, taxinc) => {
        return {
            "CUSCODE": strCusCode,
            "TACCODE": taxcode,
            "TAXREG": taxReg,
            "STATUS": status ? true : false,
            "TAXINC": setIntFromBool(taxinc)
        }
    }

    //**************Vas Table Object */
    const CustomerVasBuilder = (strCusCode, code, account) => {
        return {
            "vcM_CODE": strCusCode,
            "vcM_PROVIDER": code,
            "vcM_ACCOUNT": account
        }
    }


    //********** True False into Int Values */
    const setIntFromBool = (blParameter) => {
        if (blParameter == true) {
            return 1;
        } else {
            return 0;
        }
    }

    //edit button function    
    const handleEdit = e => {
        setDisabled(false)
        setDisabledCode(true)
        setSaveEnable(true)
        SetDeleteEnable(true)
        SetEditEnable(false)
    }

    //new button function
    const handleNew = e => {
        // e.preventDefault()
        ClearItem();
        setShow(false)
        setSaveEnable(true)
        setCrEnable(false)

    }


    function tog_xlarge() {
        setmodal_xlarge(!modal_xlarge)
        removeBodyCss()
    }

    //removebodyCss function
    function removeBodyCss() {
        document.body.classList.add("no_padding")
    }


    //* Documents Save  */
    const Documents = () => {

        let TblLine = []
        attachFileNames.map((item, index) => {

            TblLine.push({
                intAHED_LINENO: parseInt(item.lineNo),
                strAHED_FILEPATH: item.fileName,
            })
        })
        return TblLine
    }
    //*End Attachment Save */


    //clear fields function    
    const ClearItem = () => {
        SetCode("")
        SetDesc("")
        SetFName("")
        SetLName("")
        SetFullName("")
        SetGroup("")
        SetRefCode("")
        SetNIC("")
        SetRefCodeGL("")
        SetActive("")
        SetLocation("")
        SetAdd1("")
        SetAdd2("")
        SetAdd3("")
        SetAdd4("")
        SetArea("")
        SetMobile1("")
        SetMobile2("")
        SetMobile3("")
        SetMobile4("")
        SetFax("")
        SetEmail("")
        SetCredit("0")
        SetCreditLim("0")
        SetGender("")
        SetDOB("")
        SetTaxState2(false)
        SetSpName("")
        SetSpDOB("")
        SetAniver("")
        SetProfesion("")
        SetDesig("")
        SetCompany("")
        SetReligion("")
        SetEthn("")
        SetLoyalStae("")
        SetLoyaltyPoints(0)
        SetLoyalCat("")
        SetOpenPoint("0")
        SetFixDiscount("0")
        SetDisGroup("")
        SetPreLan("")
        SetEbil("")
        SetRPEmail("")
        SetRPSMS("")
        SetMobile("")
        SetProvider("")
        SetFile("")
        SetRef("")
        setVasRow([])
        SetPoint(false)
        SetAniMonth("")
        SetAniDay("")
        SetAddNew(true)
        setErrorMsg('')
        SetActive(true)
        setDisabledCode(false)
        setDisabled(false)
        setCrEnable(false)
        setPicture(photovalues)
        SetGenDOB(false)
        SetDeleteEnable(false)
        SetFileValue("")
        setReferences({
            reference1: "",
            reference2: "",
            reference3: "",
            reference4: "",
            reference5: ""
        })
        setExcelSheet3([])
        setExcelSheet2([])
        setExcelItems([])
        setarRow([{
            id: 1,
            code: "",
            desc: "",
            taxreg: "",
            state: false,
            inc: false
        }])
        setHandleClear(prev => !prev)
        setTimeout(() => {
            setExcelSheet3([])
            setExcelSheet2([])
            setExcelItems([])
            setVasRow([{
                id: 1,
                code: "",
                desc: "",
                account: "",

            }])
        }, 1)
        SetDeleteEnable(false)
        setNullCode(false)
        setSearchdisabled(false)
        SetDisableSearch(false)
        toggleCustom("1")
        setReason("Created")
        SetEditEnable(false)
        setSaveEnable(true)
        setPermissionName("")
        setPermissionPassword("")
        setPermissionNameDisable(false)
        setCodeButton(true)
        setCurrentPage(1)
        setHandleClearStatus(prev => !prev)
    }


    const handleDelete = async () => {


        SetLoadingAlert(true)
        SetLoadingAlerttitle("Deleting...")


        const rowDelete = {
            "strMenuCode": menuCode,
            "strCode": strCusCode,
            "strLoggedCompany": LogCompanyCode,
            "strLoggedLocation": LocationCode,
            "strReason": Reason,
            "strCreateBy": LogUserType
        }



        fetch(`${ApiURL}Common/Delete`,
            {
                method: "POST",
                headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
                body: JSON.stringify(rowDelete)
            }
        ).then(Response => {
            if (Response.status == "200") {
                SetLoadingAlert(false)
                Response.json()
                    .then(responseData => {
                        if (responseData.data == "Cannot Delete, Record Already Used!") {
                            displayAlertMessage('warning', responseData.data)

                        } else {
                            ClearItem();
                            displayAlertMessage('success', responseData.data)
                        }
                    }
                    )
            } else if (Response.status == "400") {
                SetLoadingAlert(false)
                Response.json()
                    .then(responseData => {
                        setErrorMsg(responseData.msg)
                    })
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Error !")

            } else {
                SetLoadingAlert(false)
                ClearItem()
            }
        }).catch(error => {
            console.log(error.message)
        })

    }
    //*********Delete button function end */


    //*** Get user selected row details */
    const GetSelectRow = (e, row, isSelect, rowIndex) => {

        SetCode(row.CM_CODE);
        getData(row.CM_CODE)
        setDisabled(true)
        setDisabledCode(true)
        setSaveEnable(false)
        setmodal_xlarge(!modal_xlarge);
        setCrEnable(true)

    }
    //*** End of getSelectedRow function */



    //************ Custome Vas table handle */
    function handleAddRowNestedVas() {
        const modifiedRows = [...vasRow]
        modifiedRows.push({ id: modifiedRows.length + 1 })
        setVasRow(modifiedRows)
    }

    function handleRemoveRowVas(id) {
        if (id !== 0) {
            var neww = []
            var modifiedRows = [...vasRow]
            modifiedRows = modifiedRows.filter(x => x["id"] !== id)
            setVasRow(modifiedRows)
        }
    }
    //************ Custome Vas table handle */



    //****** Navigation Buttons */
    const toggleCustom = tab => {
        if (customActiveTab !== tab) {
            setcustomActiveTab(tab)
        }
    }


    //********* NIC Validation */
    const NicValidate = (NIC) => {

        var mon =
        {
            "1": ["01", 31],
            "2": ["02", 29],
            "3": ["03", 31],
            "4": ["04", 30],
            "5": ["05", 31],
            "6": ["06", 30],
            "7": ["07", 31],
            "8": ["08", 31],
            "9": ["09", 30],
            "10": ["10", 31],
            "11": ["11", 30],
            "12": ["12", 31]
        };
        if (NIC.length == 10) {
            var year = "19" + NIC.substr(0, 2);
            var days = parseInt(NIC.substr(2, 3));
            if (days > 500) {
                SetGender("F")
                days = days - 500;
            }
            else {
                SetGender("M")
            }
            var key;
            for (key in mon) {
                if (days > mon[key][1]) {
                    days = days - mon[key][1];
                }
                else {
                    break;
                }
            }
            if (days < 10) {
                days = "0" + days;
            }

            var date = year + "-" + mon[key][0] + "-" + days
            SetDOB(date)
            SetGenDOB(!genDOB)

        } else if (NIC.length == 12) {
            // Definitions for month-day limits (not real; example purposes)
            const monthDayThreshold = 366;  // Example threshold for male

            if (NIC.length !== 12) {
                console.error("NIC must be exactly 12 digits long.");
                return;
            }

            let year = NIC.substr(0, 4);
            let combinedMonthDay = parseInt(NIC.substr(4, 3), 10);  // This is '054' in the example
            let sequence = NIC.substr(8, 4); // Optional use

            // Gender determination and adjusting day range
            let gender;
            if (combinedMonthDay > 500) {
                gender = "F";
                combinedMonthDay -= 500;
            } else {
                gender = "M";
            }

            // Set gender
            SetGender(gender);

            // Hypothetical method to determine month and day from combinedMonthDay
            // This needs specific logic based on how month and day are encoded in combinedMonthDay
            let month, day;
            if (combinedMonthDay <= monthDayThreshold) {
                // Calculate month and day (simple placeholder logic)
                month = Math.floor((combinedMonthDay - 1) / 31) + 1;
                day = (combinedMonthDay - 1) % 31 + 1;
            }

            // Validate extracted month and day
            if (month < 1 || month > 12 || day < 1 || day > 31) {
                console.error("Extracted month or day is out of valid range.");
                return;
            }

            // Formatting month and day for uniformity
            month = month.toString().padStart(2, '0');
            day = day.toString().padStart(2, '0');

            // Construct date of birth
            let dateOfBirth = `${year}-${month}-${day}`;

            // Set date of birth and toggle state
            SetDOB(dateOfBirth);
            SetGenDOB(true);
        } else {
            SetGenDOB(false)
        }

    }


    //****** Tab list */
    const tabList = [
        {
            text: "General Information",
            icon: "fas fa-home",
            tabID: "1",
            onClick: () => {
                toggleCustom("1")
            }
        },
        {
            text: "Contact Details",
            icon: "far fa-user",
            tabID: "2",
            onClick: () => {
                toggleCustom("2")
            }
        },
        {
            text: "Credit & Tax details ",
            icon: "far fa-user",
            tabID: "3",
            onClick: () => {
                toggleCustom("3")
            }
        },
        {
            text: "Personal details",
            icon: "far fa-user",
            tabID: "4",
            onClick: () => {
                toggleCustom("4")
            }
        },
        {
            text: "Loyalty & discount details",
            icon: "far fa-user",
            tabID: "5",
            onClick: () => {
                toggleCustom("5")
            }
        },
        {
            text: "VAS Details",
            icon: "far fa-user",
            tabID: "6",
            onClick: () => {
                toggleCustom("6")
            }
        },

        {
            text: "Ledger Details",
            icon: "far fa-user",
            tabID: "7",
            onClick: () => {
                toggleCustom("7")
            }
        },

        {
            text: "Documents",
            icon: "far fa-user",
            tabID: "8",
            onClick: () => {
                toggleCustom("8")
            }
        },
        {
            text: "References",
            icon: "far fa-user",
            tabID: "9",
            onClick: () => {
                toggleCustom("9")
            }
        }
    ];

    //CODE AUTO GEN
    const AutoGenerateCode = async () => {

        var autoCodeRes = await fetchAutoCode(menuCode)

        if (autoCodeRes.nullCode == false) {
            setAutoCode(autoCodeRes.autoCode)
        } else {
            setNullCode(true)
            setAutoCode("")
        }

    }


    //**Permission Check */
    const permission = (operation) => {
        const permissiondata = {
            strUsername: permissionName,
            strPassword: permissionPassword,
            strLocation: LocationCode,
            strMenuCode: menuCode
        }

        clearPermissionInputs()

        fetch(`${ApiURL}login/userpermission`,
            {
                method: "POST",
                headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
                body: JSON.stringify(permissiondata)
            }
        ).then(Response => {
            if (Response.status == "200") {
                Response.json()
                    .then(responseData => {
                        let Access = (responseData.data.strMenuAccessRight)
                        let Create = (responseData.data.strMenuCreateRight)
                        let Delete = (responseData.data.strMenuDeleteRight)
                        let Modify = (responseData.data.strMenuModifyRight)
                        let Print = (responseData.data.strMenuPrintRight)
                        let Process = (responseData.data.strMenuProcessRight)

                        if (operation == "Save") {
                            if (Create == true) {
                                handlesave()
                            } else if (Modify == true) {
                                handlesave()
                            } else {
                                if (operation == "Save" && addNew == true) {
                                    displayAlertMessage('danger', "This user dosen't have permission to save")

                                } else {
                                    displayAlertMessage('danger', "This user dosen't have permission to edit")

                                }
                            }
                        } else if (operation == "Delete") {
                            if (Delete == true) {
                                handleDelete()
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to delete !")

                            }
                        } else if (operation == "Print") {
                            if (Print == true) {

                                setprintoptionShow(true)

                            } else {
                                displayAlertMessage('danger', "This user don't have permission to print !")

                            }
                        } else if (operation == "XCEL") {
                            if (Print == true) {
                                handlePrint("XCEL")

                            } else {
                                displayAlertMessage('danger', "This user don't have permission to print !")
                            }
                        }
                    }
                    )

            } else if (Response.status == "400") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Oops something went wrong !")
                clearPermissionInputs()

            } else if (Response.status == "403") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "You have not Permission to make changes !")
                clearPermissionInputs()

            } else if (Response.status == "404") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Password or User Name is Invalid !")
                clearPermissionInputs()

            } else {
                ClearItem()
            }
        }).catch(error => {
            console.log(error.message)
        })
    }


    // print Function
    async function handlePrint(option) {
        var option = option
        SetLoadingAlert(true)
        SetLoadingAlerttitle("Generating Report...")

        const ReportURL = window.Links.ReportURL
        await fetch(`${ReportURL}api/customer/report/${option == "PDF" ? 1 : 0}/${LogUserType}/${menuCode}/${strCusCode}`, {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` }
        }).then(Response => Response.json())
            .then(responseData => {
                if (responseData.success == true) {
                    if (option == "PDF") {
                        const msg = responseData.msg
                        window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.pdf`)
                    }
                    if (option == "XCEL") {
                        const msg = responseData.msg
                        window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.xls`)
                    }

                }
                SetLoadingAlert(false)
            }).catch(error => {
                console.log(error.message)
                SetLoadingAlert(false)
            })
    }

    function RemoveImage() {
        setPicture(photovalues)
        setImgName("")
        SetFileValue("")

    }


    // Function for displaying Alert Messages.
    function displayAlertMessage(color, message) {
        setAlertColor(color)
        setAlertMsg(message)
        setShow(true)

        setTimeout(() => {
            setShow(false)
        }, time)
    }


    //handle permission alert
    function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
        setPermissionName(LogUserType)
        setReason(reason)
        setPermissionNameDisable(disable)
        setPermissionAlertShow(alertShow)
    }


    //Clear permission name & password
    function clearPermissionInputs() {
        setPermissionName("");
        setPermissionPassword("");
        setReason("");
    }

    //Handle Favourite Button
    const handleFavourite = async () => {
        var response = await addtoFavourite(menuCode, LogUserType);
    }


    const validateSpecialCharacters = (str) => {
        const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;
        return specialCharRegex.test(str);
    };


    //validate customer groups
    async function validateCustomerGroup(grpCode) {
        const request = await fetch(`${ApiURL}customergroup/getMenu/${grpCode}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            }
        })
        const response = await request.json();
        if (response.success == false) {
            SetGroup("")
        } else if (response.success == true && response.data.permissionRequired == "0") {
            SetGroup(grpCode)
        } else if (response.success == true && response.data.permissionRequired == "1") {
            var responseData = await getSelectedMasterPermissions(LogUserType, response.data.menuCode)
            if (responseData.strMenuAccessRight) {
                SetGroup(grpCode)
            } else {
                SetGroup("")
                displayAlertMessage('danger', "You do not have permissions for select this customer group!")
            }
        } else {
            displayAlertMessage('danger', "You do not have permissions for select this customer group!")
        }
    }


    return (
        <React.Fragment>

            <div className="page-content">
                <MetaTags>
                    <title>{menuName}</title>
                </MetaTags>
                <Container fluid={true}>
                    <Breadcrumbs title={parentName} breadcrumbItem={menuName} />
                    <DPAlert
                        confirm_both={sweetAlertShow}
                        title={menuName}
                        description={AlertDescription}
                        showCancel={true}
                        btnColor={"success"}
                        cancelColor={"danger"}
                        onConfirm={() => {
                            setsweetAlertShow(false)
                            if (AlertConfirmOption == 1) {

                                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                                    handlesave()
                                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                                    handlePermissionAlert(LogUserType, "Created", true, true)
                                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                                    handlesave()
                                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {
                                    handlePermissionAlert(LogUserType, "Updated", true, true)
                                } else {
                                    setPermissionReasonShow(true)
                                    setPermissionAlertShow(true)
                                }

                            } else if (AlertConfirmOption == 2) {
                                handleEdit()
                            } else if (AlertConfirmOption == 3) {
                                history.push('/dashboard')
                            } else if (AlertConfirmOption == 4) {
                                handleNew()
                            } else if (AlertConfirmOption == 6) {
                                if (menuPrint == true && permissionReasonShow == false) {
                                    setprintoptionShow(true)
                                } else if (menuPrint == true && permissionReasonShow == true) {
                                    handlePermissionAlert(LogUserType, "Printed", true, true)
                                } else {
                                    setPermissionReasonShow(true)
                                    setPermissionAlertShow(true)
                                }
                            } else if (AlertConfirmOption == 5) {

                                if (addNew == false && menuDelete == true && permissionReasonShow == false) {
                                    handleDelete()
                                } else if (addNew == false && menuDelete == true && permissionReasonShow == true) {
                                    handlePermissionAlert(LogUserType, "Deleted", true, true)
                                } else {
                                    setPermissionReasonShow(true)
                                    setPermissionAlertShow(true)
                                }

                            }
                        }}
                        onCancel={() => {
                            setsweetAlertShow(false)
                        }}
                    />
                    <DPPermission
                        confirm_both={permissionAlertShow}
                        title={menuName}
                        description={permissionAlertTitle}
                        showReason={permissionReasonShow}
                        nameDisable={permissionNameDisable}
                        showCancel={true}
                        btnColor={"success"}
                        cancelColor={"danger"}
                        AlName={permissionName}
                        AlNameOnchange={e => {
                            let val2 = Text(e.target, 50, true, false, "any", true)
                            setPermissionName(val2)
                        }}
                        AlPassward={permissionPassword}
                        AlPasswardOnchange={e => {
                            let val2 = Text(e.target, 50, true, false, "any", true)
                            setPermissionPassword(val2)
                        }}
                        AlReason={Reason}
                        AlReasonOnchange={e => {
                            let val2 = Text(e.target, 50, true, false, "any", true)
                            setReason(val2)
                        }}
                        onConfirm={() => {
                            setPermissionAlertShow(false)
                            if (AlertConfirmOption == 1) {
                                permission("Save")
                            } else if (AlertConfirmOption == 5) {
                                permission("Delete")
                            } else if (AlertConfirmOption == 6) {
                                permission("Print")
                            }
                        }}
                        onCancel={() => {
                            setPermissionAlertShow(false)
                            clearPermissionInputs()
                        }}
                    />
                    <DPPrintOption
                        confirm_both={printoptionShow}
                        title={menuName}
                        showCancel={true}
                        cancelColor={"danger"}
                        onConfirmpdf={() => {
                            handlePrint("PDF")
                            setprintoptionShow(false)
                        }}
                        onConfirmxcel={() => {
                            handlePrint("XCEL")
                            setprintoptionShow(false)
                        }}
                        onCancel={() => {
                            setprintoptionShow(false)
                        }}
                    />
                    <DPLoadingAlert
                        confirm_both={loadingAlert}
                        title={loadingAlertTitle}
                    />
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <DPTopToolBar
                                        //Help Button
                                        helpEnable={helpUrl != "" ? true : false}
                                        helpClick={() => {
                                            window.open(helpUrl)
                                        }}

                                        //Favorite Button
                                        favoriteEnable={true}
                                        favoriteClick={handleFavourite}
                                        //New Button
                                        newEnable={true}
                                        newClick={() => {
                                            setAlertDescription("Do you wish to refresh the screen ?");
                                            setAlertConfirmOption(4)
                                            setsweetAlertShow(true)
                                        }}
                                        //Save Button
                                        saveEnable={saveEnable && isHeadOffice}
                                        saveClick={() => {
                                            setAlertDescription("Do you wish to save ?");
                                            setAlertConfirmOption(1)
                                            setsweetAlertShow(true)
                                        }}
                                        //ProcessButton
                                        processEnable={false}
                                        processClick={() => {
                                            alert("Process")
                                        }}
                                        //Edit Button
                                        editEnable={editEnable && isHeadOffice}
                                        editClick={() => {
                                            setAlertDescription("Do you wish to edit ?");
                                            setAlertConfirmOption(2)
                                            setsweetAlertShow(true)
                                        }}
                                        //Print Button
                                        printEnable={true}
                                        printClick={() => {
                                            setReason("Printed")
                                            setAlertDescription("Do you wish to Print ?");
                                            setAlertConfirmOption(6)
                                            setsweetAlertShow(true)
                                        }}
                                        //Delete Button
                                        deleteEnable={deleteEnable}
                                        deleteClick={() => {
                                            setReason("Deleted")
                                            setAlertDescription("Do you wish to delete ?");
                                            setAlertConfirmOption(5)
                                            setsweetAlertShow(true)
                                        }}
                                        //Exit Button
                                        exitEnable={true}
                                        exitClick={() => {
                                            setAlertDescription("Do you wish to exit ?");
                                            setAlertConfirmOption(3)
                                            setsweetAlertShow(true)
                                        }}
                                    />

                                    <DPNavBar
                                        buttons={tabList}
                                        activeStatus={customActiveTab}
                                    />
                                    <TabContent
                                        activeTab={customActiveTab}
                                        className="p-3 text"
                                    >{show ? (
                                        <Alert color={AlertColor} role="alert">
                                            {AlertMsg}
                                            <br />
                                            <small>{ErrorMsg}</small>
                                        </Alert>
                                    ) : null}
                                        <TabPane tabId="1">
                                            <CustomerMasterTab1
                                                fieldManager={
                                                    (fieldManager[menuCode]) ? fieldManager[menuCode] : { hidden: false, disable: [] }
                                                }
                                                CusCodeVlaue={strCusCode}
                                                CusCodeOnBlur={e => {
                                                    getData(e.target.value)
                                                }}
                                                CusCodeOnChange={e => {
                                                    var val1 = Text(e.target, 10, true, false, "upper", false)
                                                    SetCode(val1)
                                                }}
                                                TitleValue={strCusDesc}
                                                TitleOnChange={e => {
                                                    SetDesc(e["value"])
                                                }}
                                                CusFNameValue={strCusFName}
                                                CusFNAmeOnChange={e => {
                                                    var val3 = Text(e.target, 50, true, true, "any", true)
                                                    SetFName(val3)
                                                }}
                                                CusLNameValue={strCusLName}
                                                CusLNameOnChange={e => {
                                                    var val4 = Text(e.target, 50, true, true, "any", true)
                                                    SetLName(val4)
                                                }}
                                                CusFuNameValue={strCusFullName}
                                                CusFuNameOnChange={e => {
                                                    var val5 = Text(e.target, 100, true, true, "any", true)
                                                    SetFullName(val5)
                                                }}
                                                CusGroupVlaue={strCusGroup}
                                                CusGroupOnChange={e => {
                                                    validateCustomerGroup(e["value"])
                                                    // SetGroup(e["value"])
                                                }}
                                                CusRefValue={strCusRefCode}
                                                CusRefOnChange={e => {
                                                    var val6 = Text(e.target, 30, true, true, "any", false)
                                                    SetRefCode(val6)
                                                }}
                                                CusNICValue={strCusNIC}
                                                CusNICOnChange={e => {
                                                    var val7 = Text(e.target, 12, true, false, "upper", false)
                                                    var nicPattern1 = /[0-9]{12}/;
                                                    var nicPattern2 = /[0-9]{9}[V|X|v|x]/;
                                                    // if (nicPattern1.test(val7) == true && val7.length == 12) {
                                                    //     var num01 = strCusNIC.slice(2,)
                                                    //     var num02 = num01.slice(0, 9)
                                                    //     var num4 = num02 + "V"
                                                    //     NicValidate(num4)
                                                    // } else if (nicPattern2.test(val7) == true && val7.length == 10) {

                                                    // } else {
                                                    //     SetGenDOB(false)
                                                    // }
                                                    NicValidate(val7)
                                                    SetNIC(val7)
                                                }}
                                                CusRCodeValue={strCusRefCodeGL}
                                                CusRCodeOnChange={e => {
                                                    var val8 = Text(e.target, 30, true, true, "any", false)
                                                    SetRefCodeGL(val8)
                                                }}
                                                ActiveSw={IsActive}
                                                SwonChange={() => {
                                                    SetActive(!IsActive)
                                                }}
                                                disablecode={disabledCode}
                                                disabled={disabled}
                                                CusLocationValue={strCusLocation}
                                                CusLocationOnChange={e => {
                                                    SetLocation(e["value"])
                                                }}
                                                imagesrc={picture.imageSrc}
                                                ShowPreview={e => {

                                                    if (e.target.files && e.target.files[0]) {
                                                        let imageFile = e.target.files[0];
                                                        const reader = new FileReader();
                                                        SetFileValue(e.target.value)
                                                        reader.onload = x => {
                                                            setPicture({
                                                                imageFile,
                                                                imageSrc: x.target.result,
                                                                imagepath: e.target.value
                                                            })
                                                        }
                                                        reader.readAsDataURL(imageFile)
                                                    }
                                                    else {
                                                        SetFileValue("")
                                                        setPicture({
                                                            imageFile: null,
                                                            imageSrc: Noimage,
                                                            imagepath: null
                                                        })
                                                    }
                                                }}
                                                modelTrigger={tog_xlarge}
                                                modelOpen={modal_xlarge}
                                                GetSelectRow={GetSelectRow}
                                                nicOnBlur={e => {
                                                    var nicPattern1 = /[0-9]{12}/;
                                                    var nicPattern2 = /[0-9]{9}[V|X|v|x]/;

                                                    if (nicPattern1.test(e.target.value) == true) {

                                                    } else if (nicPattern2.test(e.target.value) == true && e.target.value.length == 10) {

                                                    } else if (e.target.value == "") {

                                                    }
                                                    else {
                                                        displayAlertMessage('danger', 'Invalid NIC number')
                                                        return
                                                    }

                                                }}
                                                fileValue={file}
                                                fileOnChange={e => {
                                                    var val9 = Text(e.target, 10, true, true, "any", false)
                                                    SetFile(val9)
                                                }}
                                                FnameOnBlur={e => {

                                                    if (strCusFullName == "") {
                                                        SetFullName(e.target.value + " " + strCusLName)
                                                        Setname1(e.target.value)
                                                    } else if (strCusFullName == name1 + " " + name2) {
                                                        SetFullName(e.target.value + " " + strCusLName)
                                                    } else if (strCusFullName != name1 + " " + name2) {
                                                        SetFullName(strCusFullName)
                                                    }

                                                }}
                                                LnameOnBlur={e => {

                                                    if (strCusFullName == "") {
                                                        SetFullName(strCusFName + " " + e.target.value)
                                                        Setnam2(e.target.value)
                                                    } else if (strCusFullName != name1 + " " + name2) {
                                                        SetFullName(strCusFullName)
                                                    } else {
                                                        SetFullName(strCusFName + " " + e.target.value)
                                                    }
                                                }}
                                                nameOnblur={e => {
                                                    SetFullName(e.target.value)
                                                }}
                                                filevalue={filevalue}
                                                menuName={menuName}
                                                onButtonClick={e => {
                                                    AutoGenerateCode()
                                                    setCodeButton(true)
                                                }}
                                                btnDisable={codeButton}
                                                SearchDisable={searchdisabled}

                                                showFileUpload={(e) => {
                                                    const file = e.target.files[0];
                                                    readExcel(file);
                                                    setvalueUpload(e.target.value)
                                                }}
                                                valueUpload={valueUpload}
                                                menuCode={menuCode}
                                                RemoveImage={RemoveImage}
                                                DisableSearch={DisableSearch}
                                                autoCode={autoCode}
                                            />
                                        </TabPane>
                                        <TabPane tabId="2">
                                            <CustomerMasterTab2
                                                fieldManager={
                                                    (fieldManager[menuCode]) ? fieldManager[menuCode] : { hidden: false, disable: [] }
                                                }
                                                Address1Value={strCusAdd1}
                                                Address1OnChange={e => {
                                                    var val1 = Text(e.target, 50, true, true, "any", true)
                                                    SetAdd1(val1)
                                                }}
                                                Address2Value={strCusAdd2}
                                                Address2onChange={e => {
                                                    var val2 = Text(e.target, 50, true, true, "any", true)
                                                    SetAdd2(val2)
                                                }}
                                                Address3Value={strCusAdd3}
                                                Address3OnChange={e => {
                                                    var val3 = Text(e.target, 50, true, true, "any", true)
                                                    SetAdd3(val3)
                                                }}
                                                Address4Value={strCusAdd4}
                                                Address4onChange={e => {
                                                    var val4 = Text(e.target, 50, true, true, "any", true)
                                                    SetAdd4(val4)
                                                }}
                                                AreaValue={strCusAre}
                                                AreaOnChange={e => {
                                                    SetArea(e["value"])
                                                }}
                                                Mobile1Value={strCusMobile1}
                                                Mobile1OnChange={e => {
                                                    let inputValue = Text(e.target, 15, true, true, "any", false)

                                                    // Remove '+' from the middle of the input
                                                    if (inputValue.indexOf('+') !== 0) {
                                                        inputValue = inputValue.replace(/\+/g, '');
                                                    }

                                                    // Allow only numbers and a single '+' at the beginning
                                                    const sanitizedValue = inputValue.replace(/[^0-9+]/g, '');

                                                    // Length validation (e.g., limit to 10 characters)
                                                    if (sanitizedValue.length <= 15) {
                                                        SetMobile1(sanitizedValue);
                                                    }
                                                }}
                                                Mobile2Value={strCusMobile2}
                                                Mobile2OnChange={e => {
                                                    let inputValue = Text(e.target, 15, true, true, "any", false)

                                                    // Remove '+' from the middle of the input
                                                    if (inputValue.indexOf('+') !== 0) {
                                                        inputValue = inputValue.replace(/\+/g, '');
                                                    }

                                                    // Allow only numbers and a single '+' at the beginning
                                                    const sanitizedValue = inputValue.replace(/[^0-9+]/g, '');

                                                    // Length validation (e.g., limit to 10 characters)
                                                    if (sanitizedValue.length <= 15) {
                                                        SetMobile2(sanitizedValue);
                                                    }

                                                }}

                                                Phone1Value={strCusMobile3}
                                                Phone1OnChange={e => {
                                                    let inputValue = Text(e.target, 15, true, true, "any", false)

                                                    // Remove '+' from the middle of the input
                                                    if (inputValue.indexOf('+') !== 0) {
                                                        inputValue = inputValue.replace(/\+/g, '');
                                                    }

                                                    // Allow only numbers and a single '+' at the beginning
                                                    const sanitizedValue = inputValue.replace(/[^0-9+]/g, '');

                                                    // Length validation (e.g., limit to 10 characters)
                                                    if (sanitizedValue.length <= 15) {
                                                        SetMobile3(sanitizedValue);
                                                    }
                                                }}

                                                Phone2Value={strCusMobile4}
                                                Phone2OnChange={e => {
                                                    let inputValue = Text(e.target, 15, true, true, "any", false)

                                                    // Remove '+' from the middle of the input
                                                    if (inputValue.indexOf('+') !== 0) {
                                                        inputValue = inputValue.replace(/\+/g, '');
                                                    }

                                                    // Allow only numbers and a single '+' at the beginning
                                                    const sanitizedValue = inputValue.replace(/[^0-9+]/g, '');

                                                    // Length validation (e.g., limit to 10 characters)
                                                    if (sanitizedValue.length <= 15) {
                                                        SetMobile4(sanitizedValue);
                                                    }
                                                }}
                                                FaxValue={strCusFax}
                                                FaxOnChange={e => {
                                                    let inputValue = Text(e.target, 15, true, true, "any", false)

                                                    // Remove '+' from the middle of the input
                                                    if (inputValue.indexOf('+') !== 0) {
                                                        inputValue = inputValue.replace(/\+/g, '');
                                                    }

                                                    // Allow only numbers and a single '+' at the beginning
                                                    const sanitizedValue = inputValue.replace(/[^0-9+]/g, '');

                                                    // Length validation (e.g., limit to 10 characters)
                                                    if (sanitizedValue.length <= 15) {
                                                        SetFax(sanitizedValue);
                                                    }

                                                }}
                                                EmailVlaue={strCusEmail}
                                                EmailOnChange={e => {
                                                    var val10 = Text(e.target, 50, true, true, "lower", false)
                                                    SetEmail(val10)
                                                }}

                                                Disabled={disabled}
                                            />
                                        </TabPane>
                                        <TabPane tabId="3">
                                            <CustomerMasterTab3
                                                fieldManager={
                                                    (fieldManager[menuCode]) ? fieldManager[menuCode] : { hidden: false, disable: [] }
                                                }
                                                strcode={strCusCode}
                                                PeriodVlaue={strCusCredit}
                                                PeriodOnChange={e => {
                                                    var val1 = Numeric(e.target, 10, 0, false)
                                                    SetCredit(val1)
                                                }}
                                                LimitValue={strCusCreditLim}
                                                LimitOnChange={e => {
                                                    var val2 = Numeric(e.target, 10, 2, false)
                                                    SetCreditLim(val2)
                                                }}
                                                Disabled={disabled}
                                                DataRow={arRow}
                                                setarRow={setarRow}
                                                creditOnBlur={e => {
                                                    if (e.target.value == "") {
                                                        SetCredit(0)
                                                    } else {
                                                        SetCredit(parseInt(e.target.value, 10))
                                                    }
                                                }}
                                                limitOnBlur={e => {
                                                    var value = DecimalValidation(e.target.value)
                                                    SetCreditLim(value)
                                                }}
                                                menuCode={menuCode}
                                                currentPageRest={currentPageRest}
                                            />
                                        </TabPane>
                                        <TabPane tabId="4">
                                            <CustomerMasterTab4
                                                fieldManager={
                                                    (fieldManager[menuCode]) ? fieldManager[menuCode] : { hidden: false, disable: [] }
                                                }
                                                GenderValue={strCusGender}
                                                GenderOnChange={e => {
                                                    SetGender(e["value"])
                                                }}
                                                DOBValue={strCusDOB}
                                                DOBOnChange={e => {
                                                    SetDOB(e.target.value)
                                                }}
                                                MarriedValue={strCusTaxState2}
                                                MarriedOnChange={() => {
                                                    SetTaxState2(!strCusTaxState2)
                                                }}
                                                SNameValue={strCusSpName}
                                                SNameOnChange={e => {
                                                    var val1 = Text(e.target, 50, true, false, "any", true)
                                                    SetSpName(val1)
                                                }}
                                                SDOBVlaue={strCusSpDOB}
                                                SDOBOnChange={e => {
                                                    SetSpDOB(e.target.value)
                                                }}
                                                WedValue={strCusWdAniver}
                                                WedOnChange={e => {
                                                    SetAniver(e.target.value)
                                                }}
                                                ProValue={strCusProfession}
                                                ProOnChange={e => {
                                                    SetProfesion(e["value"])
                                                }}
                                                DesigValue={strCusDesig}
                                                DesigOnChange={e => {
                                                    SetDesig(e["value"])
                                                }}
                                                CompVlaue={strCusCompany}
                                                CompOnChange={e => {
                                                    SetCompany(e["value"])
                                                }}
                                                ReliValue={strCusReligion}
                                                ReliOnChange={e => {
                                                    SetReligion(e["value"])
                                                }}
                                                EthnValue={strCusEthn}
                                                EthnOnChange={e => {
                                                    SetEthn(e["value"])
                                                }}
                                                Disabled={disabled}
                                                genDOB={genDOB}
                                                mmValue={aniMonth}
                                                mmOnchange={e => {
                                                    var val1 = Numeric(e.target, 2, false, false)
                                                    SetAniMonth(val1)
                                                }}
                                                mmOnBlur={e => {
                                                    var val = e.target.value
                                                    if (val > 0 && val < 13) {
                                                        if (val < 10) {
                                                            SetAniMonth("0" + parseInt(e.target.value, 10))
                                                        } else {
                                                            SetAniMonth(e.target.value)
                                                        }
                                                    } else {
                                                        SetAniMonth("")
                                                    }
                                                }}
                                                ddValue={aniDay}
                                                ddOnChange={e => {
                                                    var val1 = Numeric(e.target, 2, false, false)
                                                    SetAniDay(val1)
                                                }}
                                                ddOnBlur={e => {
                                                    var val = parseInt(e.target.value, 10)
                                                    var val1 = parseInt(aniMonth, 10)
                                                    if (aniMonth == "") {
                                                        SetAniDay("")
                                                    } else if (val1 == 1 || val1 == 3 || val1 == 5 || val1 == 7 || val1 == 8 || val == 10 || val1 == 12) {
                                                        if (val > 0 && val < 32) {
                                                            if (val < 10) {
                                                                SetAniDay("0" + val)
                                                            } else {
                                                                SetAniDay(val)
                                                            }
                                                        } else {
                                                            SetAniDay("")
                                                        }
                                                    } else if (val1 == 2) {
                                                        if (val > 0 && val < 30) {
                                                            if (val < 10) {
                                                                SetAniDay("0" + val)
                                                            } else {
                                                                SetAniDay(val)
                                                            }
                                                        } else {
                                                            SetAniDay("")
                                                        }
                                                    } else {
                                                        if (val > 0 && val < 31) {
                                                            if (val < 10) {
                                                                SetAniDay("0" + val)
                                                            } else {
                                                                SetAniDay(val)
                                                            }
                                                        } else {
                                                            SetAniDay("")
                                                        }
                                                    }
                                                }}
                                            />
                                        </TabPane>
                                        <TabPane tabId="5">
                                            <CustomerMasterTab5
                                                fieldManager={
                                                    (fieldManager[menuCode]) ? fieldManager[menuCode] : { hidden: false, disable: [] }
                                                }
                                                LoyalVlaue={strCusLoyalStae}
                                                LoyalOnChange={e => {
                                                    SetLoyalStae(e.target.value)
                                                }}
                                                LoyalCatValue={strCusLoyalCat}
                                                LoyalCatOnChange={e => {
                                                    SetLoyalCat(e["value"])
                                                }}
                                                OpenPointValue={strCusOpenPoint}
                                                OpenPontOnChange={e => {
                                                    var val1 = Numeric(e.target, 10, 0, false)
                                                    SetOpenPoint(val1)
                                                }}
                                                openPointOnBlur={e => {
                                                    if (e.target.value == "") {
                                                        SetOpenPoint(0)
                                                    } else {
                                                        SetOpenPoint(parseFloat(e.target.value, 10))
                                                    }
                                                }}
                                                FDisValue={strCusFixDiscount}
                                                FDisOnChange={e => {
                                                    var val2 = Numeric(e.target, 5, 2, false)
                                                    SetFixDiscount(val2)
                                                }}
                                                discountOnBlur={e => {

                                                    var val2 = DecimalValidation(e.target.value)

                                                    if (val2 <= 100) {
                                                        SetFixDiscount(val2)
                                                    } else {
                                                        SetFixDiscount(0)
                                                    }
                                                }}
                                                DisGroupValue={strCusDisGruop}
                                                DisGroupOnChange={e => {
                                                    SetDisGroup(e["value"])
                                                }}
                                                PreLanValue={strCusPreLAn}
                                                PreLanOnChange={e => {
                                                    SetPreLan(e["value"])
                                                }}
                                                EBillValue={strCusEbil}
                                                EBillOnChange={() => {
                                                    SetEbil(!strCusEbil)
                                                }}
                                                REmailValue={strCusRPEmail}
                                                REmailOnChange={() => {
                                                    SetRPEmail(!strCusRPEmail)
                                                }}
                                                RSMSVlaue={strCUsRPSMS}
                                                RSMSOnChange={() => {
                                                    SetRPSMS(!strCUsRPSMS)
                                                }}
                                                MobileVlaue={strCusMobile}
                                                MobileOnChange={() => {
                                                    SetMobile(!strCusMobile)
                                                }}
                                                Disabled={disabled}
                                                OpenPoint={openPoint}
                                                loyaltyPoints={loyaltyPoints}
                                            />

                                        </TabPane>
                                        <TabPane tabId="6">
                                            <CustomerMasterTab6
                                                fieldManager={
                                                    (fieldManager[menuCode]) ? fieldManager[menuCode] : { hidden: false, disable: [] }
                                                }
                                                disabled={disabled}
                                                CodeValue={strCusCode}
                                                ProviderValue={strCusProvider}
                                                ProviderOnchange={e => {
                                                    SetProvider(e["value"])
                                                }}
                                                RefNoVlaue={strCusRef}
                                                RefNoOnChage={e => {
                                                    var val1 = Numeric(e.target, 20, false, false)
                                                    SetRef(val1)
                                                }}
                                                Disabled={disabled}
                                                DataRow={vasRow}
                                                setVasRow={setVasRow}
                                                RemoveRow={handleRemoveRowVas}
                                                AddRow={handleAddRowNestedVas}
                                                menuCode={menuCode}
                                                currentPageRest={currentPageRest}

                                            />
                                        </TabPane>

                                        <TabPane tabId="7">
                                            <CustomerMasterTab7
                                                customerCode={strCusCode}
                                                handleClear={handleClear}
                                            />
                                        </TabPane>

                                        <TabPane tabId="8">
                                            <CustomerMasterTab8
                                                selectedAttachFiles={selectedAttachFiles}
                                                setAttachFileNames={setAttachFileNames}
                                                attachFileNames={attachFileNames}
                                                setSelectedAttachFiles={setSelectedAttachFiles}
                                                clearStatus={handleClearStatus}
                                                disable={disabled}
                                                clearAttachmentEdit={clearAttachmentEdit}
                                            />
                                        </TabPane>
                                        <TabPane tabId="9">
                                            <CustomerMasterTab9
                                                rerefencesOnChange={rerefencesOnChange}
                                                references={references}
                                                disabled={disabled}
                                            />
                                        </TabPane>
                                    </TabContent>
                                    <Row>
                                        {crEnable ? (
                                            <DPInfoBox
                                                createdBy={crBy}
                                                createdOn={crDate != '1900-01-01 00:00:00' ? (crDate) ? crDate.replace('T', ' ') : "" : ''}
                                                modifiedBy={mdBy}
                                                modifiedOn={mdDate != '1900-01-01 00:00:00' ? (mdDate) ? mdDate.replace('T', ' ') : "" : ''}
                                            />
                                        ) : null}
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
}
export default CustomerMaster